import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '@/assets/images/beginTime.png';
import _imports_1 from '@/assets/images/endTime.png';
const _hoisted_1 = {
  class: "leave"
};
const _hoisted_2 = {
  key: 1,
  class: "content"
};
const _hoisted_3 = {
  class: "box"
};
const _hoisted_4 = {
  class: "line"
};
const _hoisted_5 = {
  class: "first"
};
const _hoisted_6 = {
  class: "name"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _ctx$queryParams$leav;
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_NavBar = _resolveComponent("NavBar");
  const _component_van_cell = _resolveComponent("van-cell");
  const _component_van_empty = _resolveComponent("van-empty");
  const _component_van_tag = _resolveComponent("van-tag");
  const _component_van_list = _resolveComponent("van-list");
  const _component_van_back_top = _resolveComponent("van-back-top");
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh");
  const _component_van_date_picker = _resolveComponent("van-date-picker");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_NavBar, {
    title: "请假单管理"
  }, {
    right: _withCtx(() => [_createVNode(_component_van_icon, {
      name: "plus",
      color: "#000",
      size: "20",
      onClick: _ctx.toVisitorAdd
    }, null, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_van_cell, {
    title: "请假日期",
    value: (_ctx$queryParams$leav = _ctx.queryParams.leaveDate) !== null && _ctx$queryParams$leav !== void 0 ? _ctx$queryParams$leav : '点击选择',
    onClick: _cache[0] || (_cache[0] = $event => _ctx.showPicker = true)
  }, null, 8, ["value"]), _createVNode(_component_van_pull_refresh, {
    modelValue: _ctx.refreshing,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _ctx.refreshing = $event),
    "success-text": "刷新成功",
    onRefresh: _ctx.onRefresh
  }, {
    default: _withCtx(() => [!_ctx.list.length ? (_openBlock(), _createBlock(_component_van_empty, {
      key: 0,
      description: "  "
    })) : (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_list, {
      loading: _ctx.loading,
      "onUpdate:loading": _cache[1] || (_cache[1] = $event => _ctx.loading = $event),
      finished: _ctx.finished,
      "finished-text": "没有更多了",
      onLoad: _ctx.onLoad,
      class: "list"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "item",
          key: index
        }, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("span", _hoisted_6, _toDisplayString(item.name) + "的请假单", 1), item.status == 0 ? (_openBlock(), _createBlock(_component_van_tag, {
          key: 0,
          type: "success"
        }, {
          default: _withCtx(() => _cache[5] || (_cache[5] = [_createTextVNode("审核通过")])),
          _: 1
        })) : _createCommentVNode("", true), item.status == 1 ? (_openBlock(), _createBlock(_component_van_tag, {
          key: 1,
          type: "warning"
        }, {
          default: _withCtx(() => _cache[6] || (_cache[6] = [_createTextVNode("待审核")])),
          _: 1
        })) : _createCommentVNode("", true), item.status == 2 ? (_openBlock(), _createBlock(_component_van_tag, {
          key: 2,
          type: "danger"
        }, {
          default: _withCtx(() => _cache[7] || (_cache[7] = [_createTextVNode("审核不通过")])),
          _: 1
        })) : _createCommentVNode("", true)]), _createElementVNode("p", null, [_cache[8] || (_cache[8] = _createElementVNode("img", {
          src: _imports_0,
          alt: ""
        }, null, -1)), _cache[9] || (_cache[9] = _createTextVNode()), _cache[10] || (_cache[10] = _createElementVNode("span", null, "开始时间：", -1)), _createTextVNode(_toDisplayString(item.beginTime), 1)]), _createElementVNode("p", null, [_cache[11] || (_cache[11] = _createElementVNode("img", {
          src: _imports_1,
          alt: ""
        }, null, -1)), _cache[12] || (_cache[12] = _createTextVNode()), _cache[13] || (_cache[13] = _createElementVNode("span", null, "截止时间：", -1)), _createTextVNode(_toDisplayString(item.endTime), 1)])])]);
      }), 128))])]),
      _: 1
    }, 8, ["loading", "finished", "onLoad"]), _createVNode(_component_van_back_top)]))]),
    _: 1
  }, 8, ["modelValue", "onRefresh"]), _createVNode(_component_van_popup, {
    show: _ctx.showPicker,
    "onUpdate:show": _cache[4] || (_cache[4] = $event => _ctx.showPicker = $event),
    position: "bottom"
  }, {
    default: _withCtx(() => [_createVNode(_component_van_date_picker, {
      modelValue: _ctx.searchDate,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _ctx.searchDate = $event),
      "cancel-button-text": "取消选中日期",
      formatter: _ctx.formatter,
      onConfirm: _ctx.onConfirm,
      onCancel: _ctx.dteCancel
    }, null, 8, ["modelValue", "formatter", "onConfirm", "onCancel"])]),
    _: 1
  }, 8, ["show"])]);
}